var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"domain",class:{ loading: _vm.isLoading }},[(_vm.isReady)?_vm._t("default"):_vm._e(),_c('error-message',{attrs:{"error":_vm.error}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }